import React from "react";

import {Card, Col} from "react-bootstrap";

import {useParams} from "react-router-dom";
import HistogramComponent from "../../components/Histogram/HistogramComponent";


function Histogram() {

    let { caseid } = useParams();
    // let caseID = caseid;
    return(
        <>
            <Col xs={{span: 10}} style={{height: "100%"}}>
                <Card style={{height: "100%"}}>
                    <Card.Body style={{position:"relative",height: "100%"}}>
                        <HistogramComponent case={caseid}/>
                    </Card.Body>
                </Card>
            </Col>


        </>
    )
}

export default Histogram;